'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

import { setAlgoliaAnalyticsContext } from '@/joystagram-components/commons/algoliaAnalyticsContext';
import getCookies from '@/joystagram-components/commons/getCookies';
import isProd from '@/joystagram-components/commons/isProd';

/**
 * Publishes the current page, host and device to the Algolia search client so
 * every browser-side search carries `analyticsTags` and `ruleContexts`
 * (CON-8651). Mounted once in the root layout.
 *
 * Writes from an effect rather than during render: effects never run on the
 * server, which is what keeps this module state out of SSR, where one
 * request's value could be read by another's.
 */
const AlgoliaAnalyticsContextSync = () => {
  const pathname = usePathname();

  useEffect(() => {
    const isProduction = isProd();

    setAlgoliaAnalyticsContext({
      host: window.location.hostname,
      cookieStoreHostName: isProduction
        ? undefined
        : getCookies().get('storeHostName'),
      isProduction,
      userAgent: navigator.userAgent,
    });
  }, []);

  useEffect(() => {
    setAlgoliaAnalyticsContext({ pathname });
  }, [pathname]);

  return null;
};

export default AlgoliaAnalyticsContextSync;
